"use client";

import { cn } from "@tosize/ui";
import { default as NextImage, type ImageProps as NextImageProps } from "next/image";
import { type FC, useState } from "react";

interface ImageProps extends Omit<NextImageProps, "alt"> {
	skipAnimation?: boolean;
	alt?: string;
}

const Image: FC<ImageProps> = ({ className, skipAnimation = false, alt, ...props }) => {
	const [isReady, setIsReady] = useState(false);
	const animate = !(props.priority || skipAnimation);

	return (
		<NextImage
			onLoad={() => {
				setIsReady(true);
			}}
			className={cn(
				{ "opacity-0 transition duration-[400ms]": !isReady && animate },
				{ "opacity-100": isReady && animate },
				className,
			)}
			alt={alt ?? ""}
			{...props}
		/>
	);
};

export default Image;
